$(document).ready(function(){
  $(".contact-popup").click(function(){
    $("#shopify-section-sections--21392175038499__1698907244c8beb181").toggle('normal');
    $("#shopify-section-sections--21392175038499__1698907244c8beb181 #close-form").toggle('normal');
    });
  });

$(document).ready(function(){
  $("#close-form").click(function(){
    $("#shopify-section-sections--21392175038499__1698907244c8beb181").toggle('normal');
    $("#shopify-section-sections--21392175038499__1698907244c8beb181 #close-form").toggle('normal');
    });
  document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    $("#shopify-section-sections--21392175038499__1698907244c8beb181").toggle('normal');
  }
})
  });

